import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class DirectorOtherEnclosure extends EntityDto implements IEntityDto {
    DirectorEnclosure_Id: string;
    Tittle: string;
    Director_Id: string;
    DirectorEnclosure_Ref_Id: string;
    IndexDocument: any ="";
   
    

    // IsActive: boolean;
    
    // TotalCount: number;
   
    constructor() {
        super();
    //     this.Qualification_Id = "00000000-0000-0000-0000-000000000000";
         this.Director_Id = "";
        this.DirectorEnclosure_Id = "";
        this.DirectorEnclosure_Ref_Id="";
    //    this.IsActive = true;
    //    this.TotalCount = 0;
  this.Tittle="";

    }
}
